import { render, staticRenderFns } from "./TabelaItensCards.vue?vue&type=template&id=596d38ae&scoped=true"
import script from "./TabelaItensCards.vue?vue&type=script&lang=js"
export * from "./TabelaItensCards.vue?vue&type=script&lang=js"
import style0 from "./TabelaItensCards.vue?vue&type=style&index=0&id=596d38ae&prod&scoped=true&lang=scss"
import style1 from "./TabelaItensCards.vue?vue&type=style&index=1&id=596d38ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d38ae",
  null
  
)

export default component.exports